/*
 * Copyright (c) 2026. BrightNight. All rights reserved.
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 * Proprietary and confidential.
 */

/** Top-right shell actions (env label + bell/user menu pill), positioned in App.tsx (px). */
export const SHELL_ACTIONS_TOP = 2;
export const SHELL_ACTIONS_RIGHT = 8;

/** Height of the action pill from getShellActionGroupSx: 30px buttons + 3px padding + 1px border. */
export const SHELL_ACTION_GROUP_HEIGHT = 30 + 2 * 3 + 2 * 1;

/** Gap between the action pill and anything stacked under it (notification toasts). */
export const SHELL_ACTIONS_GAP = 12;
